import { useState } from "react";
import { useSelector } from "react-redux";
import { Badge } from "react-bootstrap";
import { Translate } from "../../../../Enums/Tranlate";
import BookingRequestsService from "../../../../../services/BookingService";
import ChangeStatusModal from "../ChangeStatus";

const CardItem = ({ item, setModal, index, setItem, setShouldUpdate }) => {
	const [statusModal, setStatusModal] = useState();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);

	return (
		<tr key={index} className="text-center">
			<td className="text-nowrap">{item?.user?.fullname || "-"}</td>
			<td className="text-nowrap">{item?.date?.split("T")[0] || "-"}</td>
			<td className="text-nowrap">{item?.vender[`name_${lang}`] || "-"}</td>
			<td className="text-nowrap">{item?.contact_number || "-"}</td>
			<td className="text-nowrap">{item?.package[`name_${lang}`] || "-"}</td>
			<td>{item?.price || "-"}</td>
			<td>
				<Badge
					className="text-capitalize cursor-pointer"
					onClick={() => setStatusModal(true)}
					variant={`${
						item?.status === "pending"
							? "success"
							: item?.status === "processing"
							? "primary"
							: item?.status === "on_the_way"
							? "warning"
							: "danger"
					} light`}>
					{Translate[lang][item?.status]}
				</Badge>
			</td>
			<td>
				<div className="d-flex align-items-center" style={{ gap: "20px" }}>
					{/* {isExist("update_all_booking") && ( */}
					<i
						className="la la-eye cursor-pointer"
						onClick={() => {
							setItem(item);
							setModal(true);
						}}
					/>
					{/* )} */}
					{/* {isExist("delete_all_booking") && ( */}
					{/* <Badge
						variant="outline-primary"
						className="cursor-pointer"
						style={{ borderRadius: "8px" }}
						onClick={() => setStatusModal(true)}>
						{Translate[lang].confirm}
					</Badge> */}
					{/* )} */}
				</div>
			</td>
			{statusModal && (
				<ChangeStatusModal
					modal={statusModal}
					setModal={() => setShouldUpdate(false)}
					setShouldUpdate={setShouldUpdate}
					item={item}
				/>
			)}
		</tr>
	);
};
export default CardItem;
